import RedirectHelper from '../../../../components/RedirectHelper';

const AccountRegistration = (): JSX.Element => {
  RedirectHelper.redirectToUserManagementWithRedirectSet('/register');
  return <></>;
};

export default AccountRegistration;
